import React from 'react';
import { H1 as TamaguiH1 } from 'tamagui';
import type { TextProps } from 'tamagui';
import { skeleton } from '../../skeleton';

type Props = TextProps & { loading?: boolean; children?: React.ReactNode };

const H1 = ({ children, loading, ...restProps }: Props) => {
  return (
    // @ts-ignore (className)
    <TamaguiH1
      display="block"
      fontSize="$40"
      lineHeight="normal"
      fontWeight="$medium"
      {...restProps}
      className={skeleton.className('line', loading)}
    >
      {children}
    </TamaguiH1>
  );
};

export default H1;
